import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCoinsBill';
/** Renders an SVG icon. */
const SvgCoinsBill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4h-9a1 1 0 1 1 0-2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4.25a1 1 0 1 1-2 0z"
      />
      <path fill="currentColor" d="M8 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m18 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.093 14.657C5.143 14.237 6.525 14 8 14s2.857.237 3.907.657c.522.21 1.012.483 1.387.838.378.357.706.865.706 1.505s-.328 1.148-.706 1.505c-.375.355-.865.629-1.387.838-1.05.42-2.432.657-3.907.657s-2.857-.237-3.907-.657c-.522-.21-1.012-.483-1.387-.838C2.328 18.148 2 17.64 2 17s.328-1.148.706-1.505c.375-.355.865-.629 1.387-.838M4.03 17l.05-.052c.13-.123.373-.28.756-.434C5.596 16.21 6.714 16 8 16s2.404.21 3.164.514c.383.153.625.31.756.434q.032.03.05.052l-.05.052c-.13.123-.373.28-.756.434C10.404 17.79 9.286 18 8 18s-2.404-.21-3.164-.514c-.383-.153-.625-.31-.756-.434z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 20.96A1 1 0 0 0 2 21c0 .64.328 1.148.706 1.505.375.355.865.629 1.387.838C5.143 23.763 6.525 24 8 24s2.857-.237 3.907-.657c.522-.21 1.012-.483 1.387-.838.378-.357.706-.865.706-1.505a1 1 0 0 0-2-.04.5.5 0 0 1-.08.092c-.13.123-.373.28-.756.434C10.404 21.79 9.286 22 8 22s-2.404-.21-3.164-.514c-.383-.153-.625-.31-.756-.434A.5.5 0 0 1 4 20.96"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 24.96A1 1 0 0 0 2 25c0 .64.328 1.148.706 1.505.375.355.865.629 1.387.838C5.143 27.763 6.525 28 8 28s2.857-.237 3.907-.657c.522-.21 1.012-.483 1.387-.838.378-.357.706-.865.706-1.505a1 1 0 0 0-2-.04.5.5 0 0 1-.08.092c-.13.123-.373.28-.756.434C10.404 25.79 9.286 26 8 26s-2.404-.21-3.164-.514c-.383-.153-.625-.31-.756-.434A.5.5 0 0 1 4 24.96"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 25v-8h2v8zM2 25v-8h2v8zm14-15a3 3 0 0 0-2.905 2.25 1 1 0 0 1-1.937-.5A5.002 5.002 0 0 1 21 13a5 5 0 0 1-3.75 4.842 1 1 0 1 1-.5-1.936A3.002 3.002 0 0 0 16 10"
      />
    </svg>
  );
};
SvgCoinsBill.displayName = displayName;
export default SvgCoinsBill;
